import { useQuery } from 'react-query';
import { getHomeAds } from '../services/advService';

const QUERY_KEY = 'homeBanners';

/**
 * Home page banner carousel data. Uses react-query for caching and deduplication.
 */
export function useHomeBanners() {
    return useQuery(QUERY_KEY, async () => {
        const data = await getHomeAds();
        return data ?? [];
    });
}
